import CryptoPrices from "./CryptoPrices";
import styles from "./home.module.css";
import "./cryptoPrice.css";
function CryptoTabs({ priceList, USDTPrice }) {
  return (
    <div>
      <div
        className={`text-light d-flex justify-content-around ${styles.CryptoTabsContainer}`}
      >
        <h5 className={`mt-2 ${styles.textPrices}`}>قیمت ارزهای دیجیتال</h5>
        <ul class="nav nav-pills">
          {priceList.map((value, index) => {
            return (
              <li class="nav-item" role="presentation">
                <button
                  class={`nav-link text-light ${index == 0 && "active"}`}
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target={`#exchange-${index}`}
                  type="button"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  {index == 0 ? "بهترین قیمت" : value[0]?.echange.exhnage_name}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      <div class="tab-content" id="myTabContent">
        {priceList.map((value, index) => {
          return (
            <div
              class={`tab-pane fade show ${index == 0 && "active"}`}
              id={`exchange-${index}`}
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <CryptoPrices information={value} USDTPrice={USDTPrice} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CryptoTabs;
